module.exports = __webpack_public_path__ + "media/images/logo-amp-0f36f1c654e54fe692eaf32afaf151c4.svg";